import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form';
import { renderFieldSelect, required, requiredSelect } from '../../util/inputs';
import { renderField } from '../../util/arraysUtil';
import adicionarDadosCteEncomenda from '../../actions/encomenda/adicionarDadosCteEncomenda';

export class AbaCte extends Component {

  render() {
    return (
      <>
        <h3>Transmissão Cte</h3>
        <div className="form-row">
          <div className="col-12 col-sm-6 col-md-6">
            <Field name='tipoServicoCte'
              options={this.props.tiposServicos.map(elemento => ({
                descricao: elemento.valor,
                nome: elemento.chave
              }))}
              onChange={(e) => this.props.adicionarDadosCteEncomenda({ ...this.props.dadosCteEncomenda, tipoServicoCte: e })}
              component={renderFieldSelect}
              label='Tipo Serviço:'
              placeholder='Selecione...' validate={requiredSelect}
              disabled={!this.props.usuarioVendeEncomendaComCte}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-6">
              <Field name="rntrc" type="text" validate={[required]} component={renderField}
                  label="Registro Nacional de Transportadores Rodoviários de Carga (RNTRC):"
                  css="form-control"
                  readOnly={!this.props.usuarioVendeEncomendaComCte}
                  onChange={(e) => this.props.adicionarDadosCteEncomenda({ ...this.props.dadosCteEncomenda, rntrc: e.target.value })}
              />
          </div>
        </div>
        <div className="form-row">
          <div className="col-12 col-sm-12 col-md-12">
            <Field name='naturezaOperacao'
              options={this.props.naturezasOperacoes.map(it => ({
                descricao: it.valor,
                nome: it.chave
              }))}
              component={renderFieldSelect}
              label="Natureza da Operação:"
              placeholder='Selecione...' validate={requiredSelect}
              onChange={(e) => this.props.adicionarDadosCteEncomenda({ ...this.props.dadosCteEncomenda, naturezaOperacao: e })}
              disabled={!this.props.usuarioVendeEncomendaComCte}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="col-12 col-sm-6 col-md-6">
              <Field name="chaveNfe" type="text" validate={[required]} component={renderField}
                  label="Chave NF-e:"
                  css="form-control"
                  readOnly={!this.props.usuarioVendeEncomendaComCte}
                  onChange={(e) => this.props.adicionarDadosCteEncomenda({ ...this.props.dadosCteEncomenda, chaveNfe: e.target.value })}
              />
          </div>
        </div>


      </>
    )
  }
}

export const mapStateToProps = state => (
  {
    tiposServicos: state.opcoesFiltrosEmissaoesCte.tipoServicoCte,
    naturezasOperacoes: state.opcoesFiltrosEmissaoesCte.naturezasOperacoes,
    usuarioVendeEncomendaComCte: state.usuarioVendeEncomendaComCte,
    dadosCteEncomenda: state.dadosCteEncomenda,
    initialValues: {
      rntrc: state.dadosCteEncomenda.rntrc,
      tipoServicoCte: state.dadosCteEncomenda.tipoServicoCte,
      naturezaOperacao: state.dadosCteEncomenda.naturezaOperacao,
      chaveNfe: state.dadosCteEncomenda.chaveNfe
    }
  });


export default connect(mapStateToProps, {
  adicionarDadosCteEncomenda
})(reduxForm({
  form: 'formularioCadastroEncomenda',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AbaCte))